import React, { useState } from "react";
import { DeviceFragment } from "generated/graphql";
import { NavLink, Redirect, Route, Switch } from "polyrouter";
import i18next, { useTranslation } from "utilities/i18n";
import { RelaySettings } from "./RelayDeviceSettings";
import { RelayDeviceCertificate } from "./RelayDeviceCertificate";
import { FeatureFlagEnabled } from "elements";

export const SETTINGS = {
  ACCOUNT: {
    url: "/account",
    title: i18next.t("ACCOUNT")
  },
  SERVER: {
    url: "/server",
    title: i18next.t("SERVER")
  }
};

export const RelaySettingsNav: React.FC<{}> = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState(undefined as undefined | string);
  const clearFilter = () => setFilter(undefined);
  const filterVal = (val: string) =>
    val.toLowerCase().includes((filter ?? "").toLowerCase());

  return (
    <ul className="menu router sub">
      <li className="filter">
        <input
          type="text"
          id="filter-input"
          data-testid="filter-input"
          className="form-control floating-input"
          placeholder={t("FILTER_SETTINGS")}
          value={filter ?? ""}
          onFocus={clearFilter}
          onChange={e => setFilter(e.target.value)}
        />
      </li>
      <li>
        <NavLink nest exact to="/certificate">
          {t("CERTIFICATE")}
        </NavLink>
      </li>
      <FeatureFlagEnabled feature={"RELAY_RPRM"}>
        <li>
          <label className="pl-75">{t("RPRM")}</label>
        </li>
        {Object.entries(SETTINGS)
          .map(([, spec]) => spec)
          .filter(({ title }) => filterVal(title))
          .map(({ title, url }) => (
            <li key={title + "key"}>
              <NavLink
                className="pl-1"
                persist={["DeviceFilterState", "InsightsFilterState"]}
                nest
                exact
                to={url}
              >
                {title}
              </NavLink>
            </li>
          ))}
      </FeatureFlagEnabled>
    </ul>
  );
};

export const RelaySettingsLoader: React.FC<{
  device: DeviceFragment;
}> = ({ device }) => {
  return (
    <Switch>
      <Route nest path="/certificate">
        <RelayDeviceCertificate device={device} />
      </Route>
      <Route nest path="/:category">
        <RelaySettings device={device} />
      </Route>
      <Route nest path="/">
        <Redirect
          persist={["DeviceFilterState", "InsightsFilterState"]}
          nest
          to="certificate"
        />
      </Route>
    </Switch>
  );
};
